<template>
	<div class="ba-detail">
		<div class="ba-head">
			<v-icon small color="primary" class="mr-1">mdi-post-outline</v-icon>
			<span class="ba-head-title">{{ titolo(item) }}</span>
			<v-chip x-small label outlined :color="stato(item.status).colore" class="ml-1">{{ stato(item.status).label }}</v-chip>
			<v-spacer></v-spacer>
			<v-btn x-small outlined color="primary" @click="$emit('edit')"><v-icon left x-small>mdi-pencil-outline</v-icon>Modifica</v-btn>
			<v-btn x-small text color="error" @click="$emit('delete')"><v-icon left x-small>mdi-delete-outline</v-icon>Elimina</v-btn>
		</div>
		<div class="ba-body">
			<div class="ba-image">
				<img v-if="item.image && !rotta" :src="item.image" alt="" @error="rotta = true" />
				<div v-else class="ba-noimg"><v-icon large color="grey lighten-1">mdi-image-off-outline</v-icon><span>Nessuna immagine</span></div>
			</div>
			<div class="ba-info">
				<div class="ba-row">
					<span class="ba-k">Pubblicazione</span>
					<span v-if="item.publishedAt"
						>{{ item.publishedAt | moment('DD/MM/YYYY HH:mm') }} <span class="ba-muted">· {{ quando(item.publishedAt) }}</span></span
					>
					<span v-else class="ba-muted">non programmata</span>
				</div>
				<div class="ba-row">
					<span class="ba-k">Prodotto</span><span>{{ item.item || '—' }}</span>
				</div>
				<div v-if="item.created_at" class="ba-row">
					<span class="ba-k">Creato</span><span>{{ item.created_at | moment('DD/MM/YYYY') }}</span>
				</div>
				<div class="ba-hint mt-3">
					<v-icon x-small class="mr-1">mdi-information-outline</v-icon>
					<template v-if="item.status === 'PUBBLICATO'">È online sul sito.</template>
					<template v-else-if="item.status === 'ANNULLATO'">Annullato: non verrà pubblicato.</template>
					<template v-else>Non è ancora online: va portato a Pubblicato dalla scheda dell'articolo.</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { stato, quando, titolo } from './formato';

// anteprima di un articolo nella lista del blog
export default {
	name: 'BlogArticleDetail',
	props: {
		item: { type: Object, required: true },
	},
	data() {
		return { rotta: false };
	},
	methods: { stato, quando, titolo },
};
</script>

<style scoped>
.ba-detail {
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 10px;
	overflow: hidden;
	background: #f3f6fa;
	white-space: normal;
}
.ba-head {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 4px;
	padding: 8px 12px;
	background: #fff;
	border-bottom: 1px solid #e1e7ef;
	font-size: 13px;
}
.ba-head-title {
	font-weight: 600;
	color: #1f2d3d;
}
.ba-body {
	display: flex;
	gap: 16px;
	padding: 12px;
}
.ba-image {
	flex: 0 0 300px;
	width: 300px;
	height: 180px;
	border-radius: 8px;
	overflow: hidden;
	background: #fff;
	border: 1px solid #e1e7ef;
}
.ba-image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}
.ba-noimg {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 4px;
	font-size: 12px;
	color: #8a96a3;
}
.ba-info {
	flex: 1 1 auto;
	min-width: 0;
	font-size: 13px;
}
.ba-row {
	display: flex;
	gap: 10px;
	padding: 4px 0;
}
.ba-k {
	flex: 0 0 100px;
	color: #8a96a3;
	font-size: 12px;
}
.ba-muted {
	color: #5f6b7a;
}
.ba-hint {
	padding: 6px 8px;
	border-radius: 6px;
	background: #fff;
	border: 1px solid #e1e7ef;
	color: #5f6b7a;
	font-size: 12px;
}
@media (max-width: 768px) {
	.ba-body {
		flex-direction: column;
		padding: 8px;
	}
	.ba-image {
		flex-basis: auto;
		width: 100%;
	}
}
</style>
